/*eslint-env node*/

/* eslint-disable no-undef */

// used for syncing config with sessionStorage in development
export const featureToggleKey = 'featureFlags';
export const featureTogglePrefix = 'Enable';

export const IS_STAGING = import.meta.env.PUBLIC_ENVIRONMENT === 'staging';
export const IS_PRODUCTION =
  import.meta.env.PUBLIC_ENVIRONMENT === 'production' || IS_STAGING;
export const IS_DEVELOPMENT = !IS_PRODUCTION;

export const defaultConfig = {
  StoreAPIURL: import.meta.env.PUBLIC_RM_STORE_API_URL,
  CloudApiUrl: import.meta.env.PUBLIC_CLOUD_API_URL,
  CloudImportApiUrl: import.meta.env.PUBLIC_CLOUD_IMPORT_API_URL,
  CloudEnterpriseApiUrl: import.meta.env.PUBLIC_CLOUD_ENTERPRISE_API_URL,
  Auth0Domain: import.meta.env.PUBLIC_AUTH0_DOMAIN,
  Auth0ClientID: import.meta.env.PUBLIC_AUTH0_CLIENT_ID,
  Auth0Audience: import.meta.env.PUBLIC_AUTH0_AUDIENCE,
  Auth0CacheLocation:
    import.meta.env.PUBLIC_AUTH0_CACHE_LOCATION === 'localstorage'
      ? 'localstorage'
      : 'memory',
  /** @deprecated use `IS_DEVELOPMENT` or `IS_PRODUCTION` instead */
  Environment: import.meta.env.PUBLIC_ENVIRONMENT,
  DefaultTestOrganizationId:
    import.meta.env.PUBLIC_DEFAULT_TEST_ORGANIZATION_ID ?? '',
  DownloadsURL: import.meta.env.PUBLIC_DOWNLOADS_URL,
  Release: import.meta.env.PUBLIC_RELEASE,
  EnableLocalization: import.meta.env.PUBLIC_ENABLE_LOCALIZATION === 'true',
  TectonicTokenKey: 'https://auth.remarkable.com/tectonic',
  RmStoreUrl: import.meta.env.PUBLIC_RM_STORE_URL ?? '',
  TrackingAPI: import.meta.env.PUBLIC_MYRM_TRACKING_API,
  TrackingCookieDomain: import.meta.env.PUBLIC_MYRM_TRACKING_COOKIE_DOMAIN,
  MethodsUrl: import.meta.env.PUBLIC_METHODS_URL ?? '',
  CloudConnectApiUrl: import.meta.env.PUBLIC_CLOUD_CONNECT_API_URL,
  LaunchDarklyClientId: import.meta.env.PUBLIC_LAUNCH_DARKLY_CLIENT_ID ?? '',
  WebappDomain: import.meta.env.PUBLIC_WEBAPP_DOMAIN ?? '',
};
export const CONFIG = defaultConfig;

export type ConfigKey = keyof typeof CONFIG;

export type FeatureToggleKey = {
  [
    key in ConfigKey
  ]: key extends `${typeof featureTogglePrefix}${infer Feature}`
    ? `${typeof featureTogglePrefix}${Feature}`
    : never;
}[ConfigKey];
